import { createDataProvider } from 'ng'
import controller from 'servicestack/query-provider.controller'

export default createDataProvider('queryProvider', {
    bindToController: { url: '@' },
    controller
});
